import { Inject, Injectable, NgZone } from '@angular/core';
import { IAppController } from 'src/app/common/contracts/controller/app-controller';
import { IDispatcher } from 'src/app/common/contracts/dispatch/dispatcher';
import { IPlatformSync, PlatformSyncToken } from 'src/app/common/contracts/sync/platform-sync';
import { AppController } from 'src/app/common/controller/app-controller';
import { Dispatcher } from 'src/app/common/dispatch/dispatcher';

import { IServiceApproval } from '@alberta/konexi-shared';
import { ServiceApprovalChannel } from 'src/app/business/serviceApproval/contracts/service-approval-channel';
import { ServiceApprovalModelName } from '../../models/model-names';
import { SyncProgressEvent } from '../../models/sync-progress-event';
import { EventService } from '../event.service';
import { SyncService } from './sync.service';

@Injectable()
export class ServiceApprovalSyncService extends SyncService<IServiceApproval> {
  constructor(
    @Inject(AppController) appController: IAppController,
    @Inject(Dispatcher) dispatcher: IDispatcher<IServiceApproval>,
    eventService: EventService<SyncProgressEvent>,
    ngZone: NgZone,
    @Inject(PlatformSyncToken) platformSync: IPlatformSync
  ) {
    super(ServiceApprovalModelName, appController, dispatcher, eventService, ngZone, platformSync);
  }

  protected async onCreated(data: IServiceApproval): Promise<void> {
    await super.onCreated(data);

    if (this.ignoreState) {
      return;
    }
    await this._dispatcher.createState(this._name, data);
  }

  public canSync(channel: string): boolean {
    return (
      channel === ServiceApprovalChannel.CREATE ||
      channel === ServiceApprovalChannel.EDIT ||
      channel === ServiceApprovalChannel.DELETE
    );
  }
}
